export default class Decryptage {
  constructor({
    trust,
  }) {
    this.trust = trust;
  }

  getTrustTitle() {
    return this.trust?.title;
  }

  getTrustLinkUri() {
    return this.trust?.link?.uri ? this.trust?.link?.uri.replace(/internal:/, '') : '';
  }

  getTrustLinkTitle() {
    return this.trust?.link?.title;
  }

  getTrustLinkOptions() {
    return this.trust?.link?.options ?? [];
  }

  getTrustText() {
    return this.trust?.text;
  }

  getTrustImage() {
    return this.trust?.image;
  }
}
